<script lang="ts">
      import LexicalElement from './LexicalElement.svelte'
      import LexicalRoot from './LexicalRoot.svelte'
      let { root } = $props()
</script>

{#key root}
<LexicalElement root={root}>
      {#if root.children}
            {#each root.children as child, i}
                  <LexicalRoot root={child}></LexicalRoot>
            {/each}
      {/if}
</LexicalElement>
{/key}